export default class ChargebeePayments {

    static get(pm, paymentData) {
        switch(pm.type) {
            case 'direct_debit':
                return ChargebeePayments.directDebit(pm, paymentData);
        }
    }

    static directDebit(pm, paymentData) {
        const scheme = pm.configuration.scheme;
        switch (scheme) {
            case 'ACH':
                return ChargebeePayments.ach(paymentData);
        }
    }

    static ach(paymentData) {
        const { first_name, routing_number, account_number, account_type } = paymentData
        return {
            bankAccount: {
                nameOnAccount: first_name,
                routingNumber: routing_number,
                accountNumber: account_number,
                accountType: account_type
            }
        }
    }

}